export default function cndFormatter(image) {
    if (!image) return
    return (image.indexOf('://') === -1) ? 'https://' + image : image;
}